import React, { Component } from 'react';
import LoadableComponent from './../PlaceholderLoading/LoadableComponent';
import HeaderLoadPlaceholder from '../PlaceholderLoading/Templates/Header/HeaderLoadPlaceholder';
import HeaderLoadErrorPlaceholder from '../PlaceholderLoading/Templates/Header/HeaderLoadErrorPlaceholder';
import { Translation } from "react-i18next";
import { LoadScript } from '../../types/LoadScript'
import { Configuration } from '../../types/Configuration';
import { RegisterTopMenuEventHandlers } from '../../helpers/helper-functions';

type Props = {
    configuration: Configuration,
    tokenIsProvided: boolean,
    onLanguageChanged: (newLangauge:string) => void,
    onLoadCallback: () => void,
    onErrorCallback: () => void,
    isoLanguageList?: string;
}

type State = {
    scriptsToBeLoaded: [LoadScript, LoadScript],
}

class DWUnifiedHeader extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            scriptsToBeLoaded: [ {} as LoadScript, {} as LoadScript]
        };
    }

    public static defaultProps: Partial<Props> = {
        isoLanguageList: 'de en es fr ja'
    }

    componentDidMount() {
        this.setState({
            scriptsToBeLoaded: [
                { url: `${this.props.configuration.unifiedheaderBaseUrl}/build/dw-unifiedheader.esm.js`, type: "module", nomodule: false },
                { url: `${this.props.configuration.unifiedheaderBaseUrl}/build/dw-unifiedheader.js`, type: "text/javascript", nomodule: true },
            ]
        });

        RegisterTopMenuEventHandlers(this.props.onLanguageChanged, this.props.configuration.postLogoutRedirect);
    }

    render() {
        const message = <Translation>{t => t("Unfortunately we could not load this menu.")}</Translation>;

        return (
            <LoadableComponent
                loadPlaceholder={HeaderLoadPlaceholder}
                errorPlaceholder={HeaderLoadErrorPlaceholder}
                scriptsToBeLoaded={this.state.scriptsToBeLoaded}
                message={message}
                {... this.props}>
                <dw-unifiedheader token-is-provided={this.props.tokenIsProvided} iso-language-list={this.props.isoLanguageList}>{this.props.children}</dw-unifiedheader>
            </LoadableComponent>
        )
    }
}

export default DWUnifiedHeader;